/* istanbul ignore file */
import {createAxiosInstance} from "@next/axios"
import env from "../../config/env"

const {PORT, REACT_APP_APP_URL} = env

const axiosInstance = createAxiosInstance({
    PORT,
    REACT_APP_APP_URL,
})

export default axiosInstance
